import React, { CSSProperties } from 'react';
import styled from '@emotion/styled';
import Spinner from './Spinner/Spinner';
import { getBackgroundTheme, getTextColor } from '../../style';

interface LoaderProps {
  active: boolean;
  customStyle?: CSSProperties;
  spinnerStyle?: CSSProperties;
  showLoadingBg?: boolean;
  width?: number;
  style?: CSSProperties;
}

const StyledLoaderContainer = styled('div')((props: LoaderProps) => ({
  display: props.active ? 'flex' : 'none',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: 'calc(100% - 53px)',
  background: props.showLoadingBg ? getBackgroundTheme().loader : 'none',
  zIndex: 994,
  ...getTextColor().DARK,
  ...(props.customStyle || {}),
}));

const StyledLoader = styled('div')({
  textAlign: 'center',
});

const LoadingBackdrop: React.FC<LoaderProps> = ({ customStyle, spinnerStyle, active, showLoadingBg = true }) => {
  return (
    <StyledLoaderContainer customStyle={customStyle} active={active} showLoadingBg={showLoadingBg}>
      <StyledLoader>
        <Spinner customStyle={spinnerStyle} />
      </StyledLoader>
    </StyledLoaderContainer>
  );
};

export default LoadingBackdrop;
